export default "__VITE_ASSET__eecec9f3__"